var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 50,
    viewBox: "0 0 95 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_66)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4897 36.3165H92.3619C93.4778 36.3165 94.3987 35.3956 94.3987 34.2796V15.7314C94.3987 14.6155 93.4887 13.6946 92.3619 13.6946H86.4897V36.3165Z",
    fill: "#061A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9209 3.68364V46.3164H3.68364V3.68364H80.9209ZM82.221 0H2.38353C1.07259 0 0 1.07259 0 2.38353V47.6165C0 48.9274 1.07259 50 2.38353 50H82.221C83.532 50 84.6046 48.9274 84.6046 47.6165V2.38353C84.6046 1.07259 83.532 0 82.221 0Z",
    fill: "#061A42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8993 21.3651L51.0727 38.3965L52.3944 26.6738H45.623L54.2363 11.6143L54.1821 21.3651H60.8993Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3132 7.67065H20.1626V42.3294H27.3132V7.67065Z",
    fill: "#E80000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5471 7.67065V42.3294H8.39648V7.67065H15.5471Z",
    fill: "#E80000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.3987,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery20);
export default __webpack_public_path__ + "static/media/battery20.10c7e2552f1cb351116d3f217e975f7e.svg";
export { ForwardRef as ReactComponent };